export default __webpack_public_path__ + "images/58ff9bb70ad0d5f5f02e32d35f9b6391-generic_1_mobile.webp";